import { render, staticRenderFns } from "./trainsCostQuery.vue?vue&type=template&id=3b87413c"
import script from "./trainsCostQuery.vue?vue&type=script&lang=js"
export * from "./trainsCostQuery.vue?vue&type=script&lang=js"
import style0 from "./trainsCostQuery.vue?vue&type=style&index=0&id=3b87413c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports